import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { EventProvider } from './contexts/EventContext'
import './styles.css'

createRoot(document.getElementById('root')!).render(<StrictMode><BrowserRouter><EventProvider><App /></EventProvider></BrowserRouter></StrictMode>)

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => { void navigator.serviceWorker.register('/sw.js') })
}
